<template>
    <div class="download">
        <van-nav-bar
            title="酒店信息"
            left-arrow
            @click-left="onClickLeft"
        />
        <div class="buttons">
            <img src="//cdn.edstatic.com/203012120000/3f2b4a4a36035619b3acda554d10a1e9/2023/07/ad7b5c61-46a2-485e-8e04-328aad51443b.png"  @click="skip()"/>
            <img src="//cdn.edstatic.com/203012120000/30620f5b8c6e1afe675ac66bd74e245a/2023/07/bd295459-b64e-471a-8b92-5bfc27dcfd67.png"  @click="goImage"/>
        </div>
        <img src="@/assets/images/cvscf2023/bottom.png" class="bottom"/>
    </div>
</template>

<script>
import Top from '../VascularSystem/components/Top.vue'
import { ButtonDetail } from '../../config/interface.js'
export default {
    components:{
        Top
    },
    data(){
        return{
             address_url:''
        }
    },
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.getButtonData();
    },
    methods:{
        goDetail(type){

        },
        //获取按钮信息
        getButtonData(){
            if(this.button_id){
                const url=ButtonDetail;
                let params={
                    button_id:this.button_id
                }
                const method="POST";
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        this.address_url=res.data.url
                        document.title=res.data.share_title;
                        if(common.is_weixin()){
                            let data=res.data;
                            common.wxShare(data.share_title,data.share_sub_title,data.share_img);
                        }
                    }
                })

            }
        },
        onClickLeft(){
            this.$router.push('/CVSCF2023/index')
        },
        skip(){
            window.location.href=this.address_url
        },
        goImage(){
            window.location.href="http://cdn.edstatic.com/203012120000/bfcf4ef6b1edb41ccf6a775a905c3ceb/2023/07/53b899cf-698e-4739-9db4-91079d03b81c.png"
        }
    }
}
</script>

<style lang="scss" scoped>
.van-nav-bar{
    background: #d8261d;
    .van-icon{
        color: white;
    }
}
.van-nav-bar /deep/.van-icon {
    color: white;
}
 .van-nav-bar /deep/.van-nav-bar__title{
    color: white;
    font-size: 16px;
    letter-spacing: 0.5px;
}
.download{
    .buttons{
        padding:15% 5%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        img{
            width: 48%;
            margin-bottom: 4%;
        }
    }
    .bottom{
        position: absolute;
        width: 100%;
        bottom: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/CVSCF2023/hotel.vue